import ArticleFourPage from './containers/ArticleFourContainer'

export default store => {
  return {
    path: '4',
    exact: true,
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, ArticleFourPage, 'articles')
      })
    },
  }
}
